import { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import ApplicantAuthContext from "../../store/applicantStore/applicant-auth-context";

const RequireApplicantFormAuth = () => {
  const location = useLocation();
  const { clientAuthInfo } = useContext(ApplicantAuthContext);

  return (
    <>
      {clientAuthInfo.isLoggedIn ? (
        <Outlet />
      ) : (
        <Navigate to="/applicant-information/login" replace state={{ from: location }} />
      )}
    </>
  );
};

export default RequireApplicantFormAuth;
